import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { Observable, of } from 'rxjs';

export const lowerEnvironmentGuard: CanActivateFn = (): Observable<boolean> => {
    const configService = inject(ConfigService);
    const router = inject(Router);
    const env = configService.environment;

    if (env === 'local' || env === 'dev' || env === 'test' || env === 'stage') {
        return of(true);
    } else {
        void router.navigateByUrl('/not-found', {
            skipLocationChange: true,
        });
        return of(false);
    }
};
